import { addFingerprintToRequest } from './utils';
import Request from '../Request';
import Service from '../Service';
import { RequestParamsSetupPassword, ResponseErrorBody } from '../../types';

export default async function(
  webToken: string,
  params: RequestParamsSetupPassword
) {
  const request = await addFingerprintToRequest(
    new Request(`/api/auth/password/recovery/${webToken}`)
      .setMethod('POST')
      .setPayload(params)
  );
  const service = new Service<any, ResponseErrorBody>(request);
  return await service.send();
}
